var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie"},[_c('div',{ref:"main2",staticStyle:{"float":"left","width":"100%","height":"200px"},attrs:{"id":"main2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }